<div
  class="o-form-group pseic-phone-form"
  fxLayoutAlign="start end"
  fxLayoutGap="20px"
  *ngIf="phoneForm"
  [formGroup]="phoneForm"
>
  <div class="u-width-125">
    <pseic-form-field
      label="Telefon"
      labelFor="prefix"
      [resizeOnError]="false"
      i18n-label="@@shared.phone"
      [component]="this"
    >
      <psei-select
        *ngIf="!readonly; else prefixInput"
        class="phone-prefix-selector"
        [disabled]="readonly"
        formControlName="prefix"
        [singleSelect]="singleSelect"
        [searchbar]="searchbar"
        [searchMatch]="'contains'"
        [output]="'value'"
        [items]="phonePrefixes"
      ></psei-select>
      <ng-template #prefixInput>
        <input
          class="o-form-field"
          id="prefix"
          type="text"
          [readonly]="true"
          formControlName="prefix"
        >
      </ng-template>
    </pseic-form-field>
  </div>
  <div class="u-width-200">
    <pseic-form-field
      [component]="this"
      [resizeOnError]="false"
      labelFor="phone"
    >
      <input
        class="o-form-field"
        id="phone"
        type="tel"
        [readOnly]="readonly"
        formControlName="number"
      >
    </pseic-form-field>
  </div>
</div>
